if (!customElements.get("cart-drawer-product-recommendation-item")) {
  customElements.define(
    "cart-drawer-product-recommendation-item",
    class CartDrawerProductRecommendationItem extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
      }

      onVariantChange(event) {
        const select = this.querySelector(
          ".cart-drawer__recommendation-item__select"
        );
        if (!select) return;

        const variantId = select.value;
        const sectionId =
          this.dataset.itemSectionId || "cart-drawer-product-recommendation-item";

        fetch(
          `${this.dataset.productUrl}?variant=${variantId}&section_id=${sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );

            const priceDestination =
              this.querySelector("[data-recommendation-price]") ||
              this.querySelector(".cart-drawer__recommendation-item__price");
            const priceSource =
              html.querySelector("[data-recommendation-price]") ||
              html.querySelector(".cart-drawer__recommendation-item__price");

            if (priceSource && priceDestination) {
              priceDestination.innerHTML = priceSource.innerHTML;
            }

            const imageDestination =
              this.querySelector(".cart-drawer__recommendation-item__info--image") ||
              this.querySelector(".cart-drawer-secondary-recommendation__media");
            const imageSource =
              html.querySelector(".cart-drawer__recommendation-item__info--image") ||
              html.querySelector(".cart-drawer-secondary-recommendation__media");

            if (imageDestination && imageSource) {
              imageDestination.innerHTML = imageSource.innerHTML;
            }

            const buttonDestination = this.querySelector(
              ".cart-drawer__recommendation-item__button"
            );
            const buttonSource = html.querySelector(
              ".cart-drawer__recommendation-item__button"
            );
            if (buttonDestination && buttonSource) {
              buttonDestination.removeAttribute("disabled");
              if (buttonSource.hasAttribute("disabled")) {
                buttonDestination.setAttribute("disabled", "disabled");
              }
              const buttonLabel = buttonSource.querySelector("span");
              const buttonLabelDestination =
                buttonDestination.querySelector("span");
              if (buttonLabel && buttonLabelDestination) {
                buttonLabelDestination.innerHTML = buttonLabel.innerHTML;
              }
            }

            const quantityDestination = this.querySelector(
              ".cart-drawer__recommendation-item__quantity-wrapper"
            );
            const quantitySource = html.querySelector(
              ".cart-drawer__recommendation-item__quantity-wrapper"
            );
            if (quantitySource && quantityDestination) {
              quantityDestination.innerHTML = quantitySource.innerHTML;
            }
          });
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.onVariantChange);
      }
    }
  );
}
